import {
    ChangeDetectionStrategy,
    Component,
    effect,
    forwardRef,
    HostBinding,
    inject,
    input,
    model,
    OnChanges,
    OnDestroy,
    OnInit,
    signal,
    SimpleChanges
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { FloatLabel } from 'primeng/floatlabel';
import { InvoiceType } from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { InputTextModule } from 'primeng/inputtext';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, takeUntil } from 'rxjs';
import { ZDatePipe } from '../../../../../shared/pipes/ZDate.pipe';
import { DateTime } from 'luxon';

@Component({
    selector: 'z-invoice-series-info',
    imports: [FormsModule, ReactiveFormsModule, InputTextModule, ZDatePipe],
    templateUrl: './z-invoice-series-info.component.html',
    styleUrl: './z-invoice-series-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,

    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZInvoiceSeriesInfoComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZInvoiceSeriesInfoComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class ZInvoiceSeriesInfoComponent implements OnInit, OnDestroy {
    @HostBinding('class') class?: string = 'flex flex-auto1';
    // @HostBinding('style') style?: string = 'flex-basis: 350px';

    private rootFormGroup = inject(FormGroupDirective);

    label = input<string | undefined>('Αριθμός Παραστατικού');
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    value = signal<string>('');
    invoiceType = signal<InvoiceType | undefined>(undefined);

    inputStyle = input<
        | {
              [klass: string]: any;
          }
        | null
        | undefined
    >(undefined);

    store = inject(Store);

    dt = DateTime;
    private observe = new Subject();

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled: boolean = false;
    model?: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        const invoice = this.rootFormGroup?.form?.getRawValue() as InvoiceType;
        this.invoiceType.set(invoice);
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        if (this.rootFormGroup != undefined) {
            const invoice =
                this.rootFormGroup.form.getRawValue() as InvoiceType;
            this.invoiceType.set(invoice);
        }
    }

    ngOnDestroy() {
        this.observe.next(true);
        this.observe.complete();
    }
}
